module.exports = __webpack_public_path__ + "static/media/video.6a3fee72.mp4";